import i18n from 'app-i18n';
import { isDateRangeValid } from 'components/forms/fields/date-range-field/date-range-field.utils';
import * as yup from 'yup';

export const setTemporaryHoursFormSchema = yup.object().shape({
  orderType: yup
    .array()
    .of(yup.string())
    .when(['pickupClosed', 'deliveryClosed'], {
      is: (pickupClosed, deliveryClosed) => !pickupClosed || !deliveryClosed,
      then: yup
        .array()
        .of(yup.string())
        .min(1, () =>
          i18n.t(
            'forms.setTemporaryHoursForm.fields.orderType.errors.required',
          ),
        ),
      otherwise: yup.array().of(yup.string()).nullable(),
    }),
  dateRange: yup
    .array()
    .required()
    .test(
      'validDateRange',
      () =>
        i18n.t(
          'forms.setTemporaryHoursForm.fields.dateRange.errors.invalidTimeRange',
        ),
      isDateRangeValid,
    ),
  timeRange: yup
    .array()
    .required()
    .test(
      'validTimeRange',
      () =>
        i18n.t(
          'forms.setTemporaryHoursForm.fields.timeRange.errors.invalidTimeRange',
        ),
      isDateRangeValid,
    ),
  pickupClosed: yup.bool().default(false),
  deliveryClosed: yup.bool().default(false),
});
